import config from 'isomorphic-config'
import pclnRequest from '@pcln/request'
import analytics from '@/shared-utils/analytics'
import {
  DealDataMappedType,
  DealDataResponseType
} from '@/components/ScrollableDealModule'
import setDealContent from './set-deal-content'

type BundleDealsSuccessfulResponse = {
  bundles: DealDataResponseType[]
}

type InputType = {
  latitude: number
  longitude: number
}

const PKG_DEALS_QUERY = `
  query PKG($input: BundleDealsInput) {
    getBundleDeals(input: $input) {
      bundles {
        cityName
        cityImageUrl
        priceAmount
        retailPriceAmount
        searchLink
        productName
        description
      }
    }
  }
`

const fetchDataFromBundleDeals = async ({
  latitude,
  longitude
}: InputType): Promise<DealDataResponseType[]> => {
  const { url, timeout } = config.client['pcln-graph']
  const result = await pclnRequest({
    url,
    timeout,
    method: 'POST',
    data: {
      query: PKG_DEALS_QUERY,
      variables: {
        input: {
          latitude,
          longitude
        }
      }
    }
  })

  const { errors, data } = result?.data

  if (errors) {
    throw new Error(
      `Error in getBundleDeals query response: ${JSON.stringify(errors)}`
    )
  }

  const { bundles }: BundleDealsSuccessfulResponse = data?.getBundleDeals || {}

  return bundles
}

const getBundleDeals = async ({
  latitude,
  longitude
}: InputType): Promise<DealDataMappedType[]> => {
  try {
    const bundles = await fetchDataFromBundleDeals({ latitude, longitude })

    return setDealContent(bundles)
  } catch (error) {
    let errorMessage: string = (error as Error).message
    const errors = (error as XMLHttpRequest)?.response?.data?.errors
    if (errors) {
      errorMessage += ` - Errors: ${JSON.stringify(errors)}`
    }

    errorMessage =
      'Failed to call Bundle Deals api!\n' +
      `lat: ${Number(latitude)}\n` +
      `lon: ${Number(longitude)}\n` +
      `message: ${errorMessage}`

    analytics.logError({ message: errorMessage })
    return []
  }
}

export default getBundleDeals
